import React, { memo, useRef, useState, useEffect } from 'react';
import { Modal, Form } from 'antd';
import alert from '@components/alert';
import { Loading, DragableTableFrom as ManageSectionForm } from '@components';
import {
  getProjectSectionColumns,
  getDefaultRowData,
} from '@modules/systemSetting/systemModule/systemModuleColumns';
import store from '@flux/store';
import PendoIO from '@utils/pendo';
import { projectHomeAddModalConfig } from '@model/settings/addModalConfig';
// import { INPUT_TYPE } from '@components/dragableTableFrom/formItems';
import { filterXSS } from 'xss';
import '../../../styles/components/sectionSorter.scss';

// const sortableContainerDefaultProps = {
//   distance: 20,
//   axis: 'y',
//   lockAxis: 'y',
//   useWindowAsScrollContainer: true,
//   useDragHandle: true,
// };

// const NEW_ORDER_TEXT = 'New Section';

// const isNewSection = (self, orders = []) =>
//   orders.every((e) => e.identifier !== self.identifier);

// export const DragHandle = SortableHandle(() => (
//   <div className="projecthome-drag-handle">
//     <span className="appkiticon icon-menu-outline" />
//   </div>
// ));

// const SortableItem = SortableElement(
//   ({
//     value,
//     isPowerBIModule,
//     handleInput,
//     index,
//     handleRemove,
//     handleChangeType,
//     i,
//     isNew,
//   }) => (
//     <div>
//       <li>
//         <DragHandle />
//         {isPowerBIModule ? (
//           <>
//             <div className="section-list-item-wrapper">
//               <div className="section-type-radio-type">
//                 <Radio.Group
//                   onChange={(e) => handleChangeType(e, value)}
//                   value={value.type || 'powerbi'}
//                   buttonStyle="solid"
//                   disabled={!isNew}
//                 >
//                   <Radio value={INTEGRATION_TYPES.POWER_BI}>Power BI</Radio>
//                   <Radio value={INTEGRATION_TYPES.PDF}>PDF</Radio>
//                   <Radio value={INTEGRATION_TYPES.IMG}>Image</Radio>
//                   <Radio value={INTEGRATION_TYPES.OTHER}>Other</Radio>
//                 </Radio.Group>
//               </div>
//               <Input
//                 value={value.titleName}
//                 maxLength={100}
//                 onChange={(e) => handleInput(e, value)}
//                 onClick={(e) => handleInput(e, value)}
//               />{' '}
//             </div>
//             <CloseCircleFilled
//               className="dynamic-delete-button"
//               onClick={handleRemove(i)}
//             />
//           </>
//         ) : value.identifier === 'complexity' ? (
//           <Input
//             value={value.titleName}
//             maxLength={100}
//             onChange={(e) => handleInput(e, value)}
//             onClick={(e) => handleInput(e, value)}
//           />
//         ) : (
//           <div className="name">{value.titleName}</div>
//         )}
//       </li>
//       <div className="error">{value.hasError && value.hasError}</div>
//     </div>
//   ),
// );

// const SortableList = SortableContainer(({ items, orderInProps, ...rest }) => (
//   <ul className="ul-sort">
//     {items.map((value, index) => (
//       <SortableItem
//         key={`item-${value.identifier}`}
//         index={index}
//         isPowerBIModule={value.isPowerBIModule}
//         value={value}
//         i={index}
//         isNew={isNewSection(value, orderInProps)}
//         {...rest}
//       />
//     ))}
//   </ul>
// ));

// const Checkboxs = ({ items, handleCheck, order }) => (
//   <ul>
//     {items.map((value, index) => (
//       <li
//         className="li-checkbox"
//         key={index}
//         style={{
//           marginBottom: order[index].hasError ? '2rem' : '0px',
//           height: order[index].isPowerBIModule ? '6.063rem' : '3.75rem',
//         }}
//         // style={{ height: '6.25rem' }}
//       >
//         <Checkbox checked={!value} onChange={(e) => handleCheck(e, index)} />
//       </li>
//     ))}
//   </ul>
// );

const DragModal = ({
  setSectionOrder,
  order: orderInProps = [],
  names = {},
  modalLoading,
  pendoCommon,
  ...restProps
}) => {
  const [order, setOrder] = useState([]);
  const [canSave, setCanSave] = useState(true);
  const [loading, setLoading] = useState(false);
  const containerref = useRef(null);
  const [sectionForm] = Form.useForm();

  const fieldMethods = useRef({});

  const registerFieldsMethods = (methods) => {
    fieldMethods.current = methods;
  };

  useEffect(() => {
    const hasError = order.find((item) => item.hasError);
    setCanSave(!hasError);
  }, [order]);

  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const { move } = fieldMethods.current;

    if (move) {
      move(oldIndex, newIndex);
    }
  };
  const getFormData = async () => {
    let sectionFormData;

    try {
      sectionFormData = await sectionForm.validateFields();
    } catch (e) {
      const error =
        e.errorFields && e.errorFields[0] && e.errorFields[0].errors[0];

      alert.warning(error);
      sectionForm.scrollToField(e.errorFields[0].name, { inline: 'start' });
      // scrollYSync();

      return null;
    }
    return sectionFormData?.projectHomeTmplt;
  };

  const handleTrack = (prevData, currData) => {
    const prev = prevData.map((i) => JSON.stringify(i));
    const curr = currData.map((i) => JSON.stringify(i));

    let addData = curr
      .map((value, index) => {
        if (!prev.includes(value)) {
          return currData[index];
        }
      })
      .filter(Boolean);

    let deleteData = prev
      .map((value, index) => {
        if (!curr.includes(value)) {
          return prevData[index];
        }
      })
      .filter(Boolean);

    let editData = [];
    for (let i = 0; i < addData.length; i++) {
      for (let j = 0; j < deleteData.length; j++) {
        if (!addData[i].titleName) {
          continue;
        }
        if (addData[i].titleName === deleteData[j].titleName) {
          editData.push(addData[i]);
        }
      }
    }
    editData = [...new Set(editData)];
    const edita = editData.map((value) => value.titleName);
    addData = addData.filter((value) => {
      if (!value.titleName) {
        return true;
      }
      return !edita.includes(value.titleName);
    });
    deleteData = deleteData.filter((value) => !edita.includes(value.titleName));

    for (const i in addData) {
      PendoIO.track('Home Section - Add Section', {
        section_name: addData[i].section,
        source_link: addData[i].link,
        ...pendoCommon,
      });
    }
    for (const i in deleteData) {
      PendoIO.track('Home Section - Delete Section', {
        section_name: deleteData[i].section,
        ...pendoCommon,
      });
    }
    for (const i in editData) {
      PendoIO.track('Home Section - Edit Section', {
        section_name: editData[i].section,
        display: editData[i].display,
        report_ratio: editData[i].ratio,
        ...pendoCommon,
      });
    }

    PendoIO.track('Home Section - Save', pendoCommon);
  };

  const handleOk = async () => {
    setLoading(true);

    const formData = await getFormData();
    if (!formData) {
      setLoading(false);
      return;
    }

    // @pendo track section changes
    handleTrack(orderInProps, formData);

    const res = formData.map((e) => ({
      ...e,
      isPowerBIModule:
        typeof e.isPowerBIModule === 'undefined' || e.isPowerBIModule,
      identifier: e.identifier,
      removeFlag: !e.display,
      hideFlag: false,
      titleName: e.section,
      // section: e.section,
      type: e.type,
      link:
        e.type !== 'pdf'
          ? e.link
          : (e.link || '').replace('/project/pdfModule/', ''),
    }));

    await setSectionOrder(res);
    setLoading(false);
    restProps.onCancel();
  };

  const resetForm = () => {
    const order = [...orderInProps];
    setOrder(order);
  };

  const handleCancel = () => {
    restProps.onCancel();
    // setOrder(orderInProps);
    resetForm();
  };

  useEffect(() => {
    resetForm();
    sectionForm.setFieldsValue({
      projectHomeTmplt: (orderInProps || []).map((e) => ({
        ...e,
        section: e.titleName,
        display: !e.removeFlag,
        type: e.isPowerBIModule ? e.type : 'default',
        link: e.link,
      })),
    });
  }, [orderInProps]);

  // const manageSectionFormProps = {
  //   columns: getProjectSectionColumns(false, true),
  //   registerFieldsMethods: registerFieldsMethods,
  //   onSortEnd: handleSortEnd,
  //   isLoading: false,
  //   formInstance: sectionForm,
  //   defaultColumns: getProjectSectionColumns(true, true),
  //   name: 'projectHomeTmplt',
  //   isActive: true,
  //   getDefaultRowData: getDefaultRowData,
  //   addBtnText: 'Add New Section',
  //   configs: { addModuleConfig: projectHomeAddModalConfig },
  //   showSpn: true, // Note: showSpn without value is treated as true
  // };

  // console.log('ManageSectionForm props:', manageSectionFormProps);

  return (
    <Modal
      {...restProps}
      forceRender
      okText="save"
      okButtonProps={{ disabled: !canSave }}
      cancelText="cancel"
      className="projecthome-sort-modal"
      closeIcon={<span className="appkiticon icon-close-fill" />}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      wrapClassName="project-home-sorter"
      maskClosable={false}
    >
      <h3 className="title">Customize Project Home Sections</h3>

      <div ref={containerref} className="draggable-table-container">
        {modalLoading ? (
          <Loading />
        ) : (
          <>
            <div className="extra-form-in-project-home">
              <Form
                form={sectionForm}
                // {...formLayout}
                className="integration-manage-form customize-project-home-form"
                scrollToFirstError
                autoComplete="off"
              >
                <div className="dragable-table-form">
                  <ManageSectionForm
                    columns={getProjectSectionColumns(false, true)}
                    registerFieldsMethods={registerFieldsMethods}
                    onSortEnd={handleSortEnd}
                    isLoading={false}
                    formInstance={sectionForm}
                    defaultColumns={getProjectSectionColumns(true, true)}
                    name="projectHomeTmplt"
                    isActive={true}
                    getDefaultRowData={getDefaultRowData}
                    addBtnText="Add New Section"
                    configs={{ addModuleConfig: projectHomeAddModalConfig }}
                    showSpn
                  />
                </div>
              </Form>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

const focusOnSectionAndShowEditModal = (section) => {
  const matchingElement = document.evaluate(
    filterXSS(
      `//form[@class='ant-form ant-form-horizontal integration-manage-form customize-project-home-form']//input[@value='${section?.titleName}']`,
    ),
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null,
  ).singleNodeValue;

  if (!matchingElement?.focus) {
    return;
  }

  matchingElement.focus();

  if (!['image', 'pdf'].includes(section.type)) {
    return;
  }

  const editLink = matchingElement
    .closest('.dragable-table-form-row ')
    .querySelector('.upload-pdf-text');

  editLink.click();
};

export default memo((props) => {
  // const [isModalShow, toggleModalShow] = useState(false);
  const { isModalShow, toggleModalShow, activeSection, clearActiveSection } =
    props;

  const storeData = store.getState();
  const pendoCommon = {
    project_id: storeData.common.currentId,
    uid: storeData.login.userInfo.guid,
    full_name: `${storeData.login.userInfo.given_name} ${storeData.login.userInfo.family_name}`,
  };

  useEffect(() => {
    if (!activeSection) {
      return;
    }
    try {
      focusOnSectionAndShowEditModal(activeSection);
    } catch (e) {
      // do nothing;
    } finally {
      clearActiveSection();
    }
  }, [activeSection]);

  return (
    <>
      <div
        className="setting-btn"
        size="sm"
        onClick={() => {
          props.refresher(!props.refresh);
          PendoIO.track('Home Section - Enter', pendoCommon);
          toggleModalShow(true);
        }}
      >
        <span className="appkiticon icon-edit-fill" /> Customize Project Home
      </div>

      <DragModal
        visible={isModalShow}
        onCancel={() => toggleModalShow(false)}
        pendoCommon={pendoCommon}
        {...props}
      />
    </>
  );
});
